import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const ADD_PRODUCT_POSITION_MUTATION = gql`
  mutation addProductLine($documentVersion: DocumentVersionInput, $productId: String!) {
    quotes {
      modify(documentVersion: $documentVersion) {
        addProductLine(productId: $productId) {
          newLines {
            id
            customProperties {
              key
              stringValue
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class AddProductPositionMutation extends Mutation<RootMutation> {
  document = ADD_PRODUCT_POSITION_MUTATION;
}
